import React from 'react';
import {StyleProp, TextStyle} from 'react-native';
import FontAwesome6 from '@react-native-vector-icons/fontawesome6';

export type IconStyle = 'solid' | 'regular' | 'brand';

export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  iconStyle?: IconStyle;
  style?: StyleProp<TextStyle>;
  testID?: string;
}

/**
 * Icon component that wraps FontAwesome6 from react-native-vector-icons
 *
 * @param name - The icon name from FontAwesome6
 * @param size - The size of the icon (default: 16)
 * @param color - The color of the icon
 * @param iconStyle - The icon style: 'solid' (default), 'regular', or 'brand'
 * @param style - Additional style to apply to the icon
 * @param testID - Test ID for testing purposes
 */
const Icon: React.FC<IconProps> = ({
  name,
  size = 16,
  color,
  iconStyle = 'solid',
  style,
  testID,
}) => {
  return (
    <FontAwesome6
      name={name}
      size={size}
      color={color}
      style={style}
      testID={testID}
      iconStyle={iconStyle}
    />
  );
};

export {Icon};
export default Icon;
